import classnames from 'classnames';
import { FunctionComponent } from 'react';

type DesignManagerLogoBlackProps = {
    className?: string;
};

const DesignManagerLogoBlack: FunctionComponent<DesignManagerLogoBlackProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'design-manager-logo-black'}
            viewBox="0 0 250 250"
        >
            <path d="M243.5 15h-5.9c-4.7 0-6.1 2.9-6.1 2.9l-66.7 104.6-36.1-65.2S119 39.1 94.6 26.7c-22.4-11.3-73.4-9.5-73.4-9.5h-7.5C6 17.2-.4 23.6-.4 31.3v175.6c0 15.4 12.6 27.9 27.9 27.9H68s-.1 0-.2-.1c37-2.4 60.7-21.8 77.6-47L119.8 146c-3.4 23.5-17.5 38.6-40.8 45.3-9.3 2.7-20.1 4-32.2 4h-2.4V56.6h.3l-.3-.2c1.9 0 19 .3 30.2 6.7 5.8 3.3 10.9 8 14.8 13.3l72.4 117.7h4.2l42.1-57v97.6h41.6V21.1c-.1-3.3-2.8-6.1-6.2-6.1z" />
        </svg>
    );
};
export default DesignManagerLogoBlack;
